import React, { Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaSearchPlus, FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import AppUrl from '../../restApi/AppUrl';
import IRestClient from '../../restApi/IRestClient';
import HtmlParser from 'react-html-parser';
import Wentwrong from '../Wentwrong/Wentwrong';
import { Link } from 'react-router-dom';
import './Recentprojectdetails.css';

/* ── Animation variants ─────────────────────────────────────────────── */
const ease = [0.22, 1, 0.36, 1];

const fadeUp = (delay = 0) => ({
    initial:  { opacity: 0, y: 36 },
    animate:  { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease, delay },
});

const fadeRight = (delay = 0) => ({
    initial:  { opacity: 0, x: 24 },
    animate:  { opacity: 1, x: 0 },
    transition: { duration: 0.55, ease, delay },
});

const scaleIn = {
    initial:  { opacity: 0, scale: 0.96 },
    animate:  { opacity: 1, scale: 1 },
    transition: { duration: 0.65, ease },
};

/* ── Skeleton placeholder ───────────────────────────────────────────── */
function ProjectSkeleton() {
    return (
        <div className="single">
            <div className="container">
                <div className="row g-4">
                    {/* Main */}
                    <div className="col-lg-8">
                        <div className="skel skel-hero" />
                        <div className="skel skel-title mt-4" />
                        <div className="skel skel-line mt-3" style={{ width: '100%' }} />
                        <div className="skel skel-line mt-2" style={{ width: '95%' }} />
                        <div className="skel skel-line mt-2" style={{ width: '88%' }} />
                        <div className="skel skel-line mt-2" style={{ width: '72%' }} />
                        <div className="skel skel-line mt-2" style={{ width: '60%' }} />
                    </div>
                    {/* Sidebar */}
                    <div className="col-lg-4">
                        <div className="skel skel-widget-title mb-3" />
                        {[1, 2, 3].map(i => (
                            <div key={i} className="d-flex align-items-center mb-3 gap-2">
                                <div className="skel skel-thumb flex-shrink-0" />
                                <div className="flex-grow-1">
                                    <div className="skel skel-line" style={{ width: '80%' }} />
                                    <div className="skel skel-line mt-2" style={{ width: '55%' }} />
                                </div>
                            </div>
                        ))}
                        <div className="skel skel-donate mt-4" />
                    </div>
                </div>
            </div>
        </div>
    );
}

class Recentprojectdetails extends Component {
    constructor(props) {
        super();
        this.state = {
            myprojectdetailsid: props.id,
            loading: true,
            project_title: '',
            project_image: '',
            project_description: '',
            project_detail_images: [],
            myProjects: [],
            error: false,
            lightboxOpen: false,
            lightboxIndex: 0,
        };
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
        document.body.style.overflow = '';
    }

    handleKeyDown = (e) => {
        if (!this.state.lightboxOpen) return;
        if (e.key === 'ArrowRight') this.lightboxNext();
        else if (e.key === 'ArrowLeft') this.lightboxPrev();
        else if (e.key === 'Escape') this.closeLightbox();
    };

    openLightbox = (index) => {
        document.body.style.overflow = 'hidden';
        this.setState({ lightboxOpen: true, lightboxIndex: index });
    };

    closeLightbox = () => {
        document.body.style.overflow = '';
        this.setState({ lightboxOpen: false });
    };

    lightboxNext = () => {
        const total = this.state.project_detail_images.length;
        this.setState(s => ({ lightboxIndex: (s.lightboxIndex + 1) % total }));
    };

    lightboxPrev = () => {
        const total = this.state.project_detail_images.length;
        this.setState(s => ({ lightboxIndex: (s.lightboxIndex - 1 + total) % total }));
    };

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
        IRestClient.GetRequest(AppUrl.Projectdetails + this.state.myprojectdetailsid)
            .then(result => {
                if (result == null) {
                    this.setState({ error: true, loading: false });
                } else {
                    this.setState({
                        project_title: result[0]['project_title'],
                        project_image: result[0]['project_image'],
                        project_description: result[0]['project_description'],
                        project_detail_images: result[0]['images'] || [],
                        loading: false,
                    });
                }
            })
            .catch(() => this.setState({ error: true, loading: false }));

        IRestClient.GetRequest(AppUrl.allprojectsindetails)
            .then(result => {
                if (result != null) this.setState({ myProjects: result });
            })
            .catch(() => {});
    }

    render() {
        if (this.state.error)   return <Wentwrong />;
        if (this.state.loading) return <ProjectSkeleton />;

        const { project_detail_images, project_title, project_image, project_description, lightboxOpen, lightboxIndex } = this.state;

        const renderGalleryItem = (img, i) => (
            <motion.div
                key={i}
                className="proj-gallery-item"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45, ease, delay: 0.3 + i * 0.07 }}
                onClick={() => this.openLightbox(i)}
            >
                <img src={img.project_image_thumb || img.project_image} alt={project_title} />
                <div className="proj-gallery-overlay"><FaSearchPlus /></div>
            </motion.div>
        );

        const myprojects = this.state.myProjects.map((project, i) => (
            <motion.div
                key={i}
                className="post-item"
                initial={{ opacity: 0, x: 16 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.4, ease, delay: 0.15 + i * 0.08 }}
            >
                <div className="post-img">
                    <img src={project.project_image} alt={project.project_title} />
                </div>
                <div className="post-text">
                    <Link
                        className="allLinks"
                        to={'/projectdetails/' + project.id + '/' + project.project_title}
                    >
                        {project.project_title}
                    </Link>
                </div>
            </motion.div>
        ));

        return (
            <>
            <div className="single">
                <div className="container">
                    <div className="row g-4">

                        {/* ── Main content ──────────────────────────────── */}
                        <div className="col-lg-8">
                            <div className="single-content">

                                <motion.div className="proj-hero-img" {...scaleIn}>
                                    <img src={project_image} alt={project_title} />
                                </motion.div>

                                <motion.h2 className="proj-title" {...fadeUp(0.15)}>
                                    {project_title}
                                </motion.h2>

                                <motion.span
                                    className="proj-title-accent"
                                    initial={{ scaleX: 0, opacity: 0 }}
                                    animate={{ scaleX: 1, opacity: 1 }}
                                    transition={{ duration: 0.45, ease, delay: 0.22 }}
                                    style={{ transformOrigin: 'left' }}
                                />

                                <motion.div className="proj-description" {...fadeUp(0.28)}>
                                    {HtmlParser(project_description)}
                                </motion.div>

                                {/* Gallery — mobile only */}
                                {project_detail_images.length > 0 && (
                                    <motion.div
                                        className="proj-mobile-gallery d-lg-none"
                                        {...fadeUp(0.35)}
                                    >
                                        <h4 className="proj-mobile-gallery-title">Project Photos</h4>
                                        <div className="proj-mobile-gallery-grid">
                                            {project_detail_images.map(renderGalleryItem)}
                                        </div>
                                    </motion.div>
                                )}
                            </div>
                        </div>

                        {/* ── Sidebar ───────────────────────────────────── */}
                        <div className="col-lg-4">
                            <div className="sidebar proj-sidebar">

                                <motion.div className="sidebar-widget" {...fadeRight(0.1)}>
                                    <h2 className="widget-title">Recent Projects</h2>
                                    <div className="recent-post">
                                        {myprojects}
                                    </div>
                                </motion.div>

                                {/* Gallery — desktop only */}
                                {project_detail_images.length > 0 && (
                                    <motion.div
                                        className="sidebar-widget d-none d-lg-block"
                                        {...fadeRight(0.2)}
                                    >
                                        <h2 className="widget-title">Project Gallery</h2>
                                        <div className="proj-image-grid">
                                            {project_detail_images.map(renderGalleryItem)}
                                        </div>
                                    </motion.div>
                                )}

                                {/* Donate widget — hidden until payment goes live */}
                                {false && (
                                    <motion.div
                                        className="sidebar-widget donate-widget"
                                        {...fadeRight(project_detail_images.length > 0 ? 0.3 : 0.2)}
                                    >
                                        <div className="donate-icon">
                                            <i className="fa fa-heart"></i>
                                        </div>
                                        <h2 className="widget-title">Your Donation Changes Everything</h2>
                                        <div className="text-widget">
                                            <p>
                                                SOYAN is committed to not only meet the individual needs
                                                but also to develop the local community based on their
                                                necessities and culture.
                                            </p>
                                            <Link to="/donate" className="btn-donate">
                                                Donate Now
                                            </Link>
                                        </div>
                                    </motion.div>
                                )}

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* ── Lightbox ──────────────────────────────────────────── */}
            <AnimatePresence>
                {lightboxOpen && (
                    <motion.div
                        className="proj-lightbox-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        onClick={this.closeLightbox}
                    >
                        <div className="proj-lightbox-topbar">
                            <span className="proj-lightbox-counter">
                                {lightboxIndex + 1} / {project_detail_images.length}
                            </span>
                            <button className="proj-lightbox-close" onClick={this.closeLightbox}>
                                <FaTimes />
                            </button>
                        </div>

                        <AnimatePresence mode="wait">
                            <motion.div
                                className="proj-lightbox-img-wrap"
                                key={lightboxIndex}
                                initial={{ opacity: 0, scale: 0.92 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.92 }}
                                transition={{ duration: 0.22 }}
                                onClick={e => e.stopPropagation()}
                            >
                                <img
                                    src={project_detail_images[lightboxIndex]?.project_image}
                                    alt={project_title}
                                />
                            </motion.div>
                        </AnimatePresence>

                        {project_detail_images.length > 1 && (
                            <>
                                <button
                                    className="proj-lightbox-nav proj-lightbox-prev"
                                    onClick={e => { e.stopPropagation(); this.lightboxPrev(); }}
                                >
                                    <FaChevronLeft />
                                </button>
                                <button
                                    className="proj-lightbox-nav proj-lightbox-next"
                                    onClick={e => { e.stopPropagation(); this.lightboxNext(); }}
                                >
                                    <FaChevronRight />
                                </button>
                            </>
                        )}

                        {project_detail_images.length > 1 && (
                            <div className="proj-lightbox-thumbs" onClick={e => e.stopPropagation()}>
                                {project_detail_images.map((img, i) => (
                                    <div
                                        key={i}
                                        className={`proj-lightbox-thumb${i === lightboxIndex ? ' active' : ''}`}
                                        onClick={() => this.setState({ lightboxIndex: i })}
                                    >
                                        <img src={img.project_image} alt="" />
                                    </div>
                                ))}
                            </div>
                        )}
                    </motion.div>
                )}
            </AnimatePresence>
            </>
        );
    }
}

export default Recentprojectdetails;
